import { Box, CircularProgress } from '@mui/material'
import { colors } from '@/components/providers/ThemeProvider/colors'

function Loading({
  background = colors.teachTeal[25],
}: {
  background?: string
}) {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        position: 'relative',
        background,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <CircularProgress
          color="primary"
          size="80px"
          aria-label="Loading page"
        />
      </Box>
    </Box>
  )
}

// eslint-disable-next-line import/no-default-export -- Next.js default policy
export default Loading
